import { GkvSubmissionAnswer, SubmissionDocumentType, TopicCategory } from '@iota/inh-core-v1-management-client';
import { SubmissionErrorKind } from '../utils/submission-error.util';
import { ACTION_ERROR_MESSAGE } from './toast-messages';

export const SUBMISSION_DOCUMENT_TYPE_LABELS: Record<SubmissionDocumentType, string> = {
    [SubmissionDocumentType.INVOICE]: $localize`Invoice`,
    [SubmissionDocumentType.PRESCRIPTION]: $localize`Prescription`,
    [SubmissionDocumentType.TREATMENT_DATES]: $localize`Treatment date`,
    [SubmissionDocumentType.COURSE_CERTIFICATE]: $localize`Course certificate`,
    [SubmissionDocumentType.INSURANCE_RESPONSE]: $localize`SHI written reply`,
    [SubmissionDocumentType.THIRD_PARTY_REIMBURSEMENT_PROOF]: $localize`Proof of third-party reimbursement`
};

export const TOPIC_CATEGORY_LABELS: Record<TopicCategory, string> = {
    [TopicCategory.EXERCISE]: $localize`Physical Activity`,
    [TopicCategory.NUTRITION]: $localize`Nutrition`,
    [TopicCategory.STRESS]: $localize`Stress Management / Relaxation`,
    [TopicCategory.ADDICTION]: $localize`Substance Use Prevention`,
    [TopicCategory.UNKNOWN]: $localize`Unknown`
};

export const GKV_SUBMISSION_ANSWER_LABELS: Record<GkvSubmissionAnswer, string> = {
    [GkvSubmissionAnswer.BUDGET_EXCEEDED]: $localize`No – I have already exceeded my prevention course budget at my health insurance and I cannot submit additional requests.`,
    [GkvSubmissionAnswer.PARTIAL_REIMBURSEMENT]: $localize`Yes – I have submitted it to my health insurance and received a reimbursement. I confirm that my health insurance did not reimburse the full amount of the course fee.`,
    [GkvSubmissionAnswer.NO_REIMBURSEMENT_ATTENDANCE]: $localize`Yes – I have submitted it to my health insurance but I cannot get a reimbursement as I did not attend 80 % or more of the course.`
};

export const SUBMISSION_ERROR_MESSAGES: Record<SubmissionErrorKind, string> = {
    invalid: $localize`The request was not accepted. Please check your entries.`,
    forbidden: $localize`You are not allowed to perform this action for this employee.`,
    notFound: $localize`The submission or employee no longer exists. Please reload the page.`,
    conflict: $localize`The submission was changed in the meantime and has been reloaded.`,
    tooLarge: $localize`The files are too large.`,
    unknown: ACTION_ERROR_MESSAGE
};
